export const getCroppedImg = (imageSrc, pixelCrop) => {
  const createImage = url =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = error => reject(error);
      image.src = url;
    });

  return createImage(imageSrc).then(image => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = 728;
    canvas.height = 80;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      728,
      80,
    );

    return new Promise(resolve => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        const file = new File([blob], 'croppedImage.jpg', {
          type: 'image/jpeg',
        });
        resolve(file);
      }, 'image/jpeg');
    });
  });
};
